import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../components/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-light-svg-icons'
import styles from './step-9.module.scss'
import WaveContainer from '../../../../components/wave-container'
import WhatYouGet from '../what-you-get'
import CompanyInfo from '../company-info'
import { removeTokenAndOrgId } from '../../../..'
import { useHistory } from 'react-router'
import { ICompanyProps } from '../../../signup-v3/dooerPreOffer'

type IStep8Variants = 'order' | 'future'

interface IStep8Props {
  onComplete: () => void
  company: ICompanyProps
  variant: IStep8Variants
}

function renderContent(variant: IStep8Variants) {
  const content = {
    order: {
      heading: {
        defaultMessage: 'Analys klar!',
        id: 'sync-bank.step-9.heading-order',
      },
      lede: {
        defaultMessage: 'Analysen av ditt företag är nu genomförd.',
        id: 'sync-bank.step-9.lede-order',
      },
      cta: {
        id: 'sync-bank.final-step.order.cta',
        defaultMessage: 'Tillbaka till förstasidan',
      },
    },
    future: {
      heading: {
        defaultMessage: 'Vi har sparat dina kontaktuppgifter',
        id: 'sync-bank.step-9.heading-future',
      },
      lede: {
        defaultMessage:
          'Tack för att du visat intresse för att använda Dooer. Vi kommer att skicka ut information till dig om vi gör ändringar som gör att vi kan ta emot ditt företag.',
        id: 'sync-bank.step-9.lede-future',
      },
      cta: {
        id: 'sync-bank.final-step.future.cta',
        defaultMessage: 'Tillbaka till förstasidan',
      },
    },
  }

  return content[variant]
}

export default function Step8({ onComplete, company, variant }: IStep8Props) {
  React.useEffect(() => {
    removeTokenAndOrgId()
  }, [])

  const history = useHistory()

  return (
    <>
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.headerInner}>
            <i className={styles.checkmark}>
              <FontAwesomeIcon icon={faCheck} />
            </i>
            <FormattedMessage {...renderContent(variant).heading} tagName="h1" />
            <FormattedMessage {...renderContent(variant).lede} tagName="p" />
            <Button
              onClick={() => {
                if (['regular', 'saving'].includes(variant)) {
                  onComplete()
                } else {
                  history.push('/byra')
                }
              }}
              variant="success"
            >
              <FormattedMessage {...renderContent(variant).cta} />
            </Button>
          </div>
        </div>
        <WaveContainer className={styles.content}>
          <WhatYouGet />
          {company && <CompanyInfo company={company} />}
        </WaveContainer>
      </div>
    </>
  )
}
